import styles from './VehicleDetails.module.css'
import { downloadFileToLocal } from "../../../../utils/downloadFile";
import { useLocation } from 'react-router-dom';
import { useSimConsent } from '../../hooks/useSimConsent';
import SimConsentStatus from './SimConsentStatus';

const vehicleDetails = ({
    lrDetails,
    indentId,
    truckDetails,
    truck_status,
}) => {
    const {
        hasAccess,
        isSendingRequest,
        isCheckingStatus,
        sendConsentRequest,
        parseConsentStatus,
        vehicleDetails,
        loading: loadingConsentDetails,
        refetchSimTrackingStatus
    } = useSimConsent(indentId);
    const location = useLocation();

    const restrictSimTracking = truck_status?.length > 0 && ["yet to be placed", "placed", "dispatched"]?.includes(truck_status?.[truck_status?.length - 1]?.value) ? false : true;

    const simConsentStatus = parseConsentStatus(vehicleDetails);

    const truck_details = vehicleDetails?.truck_details || truckDetails;

    const getLatestLRFile = () => {
        if (!lrDetails?.file_uploads?.length) return null;

        const lrFiles = lrDetails?.file_uploads?.filter(
            (file) => (file?.type === "lr" || file?.file_type === "lr_upload") && !file?.isdeleted
        );

        if (!lrFiles.length) return null;

        return lrFiles?.[lrFiles.length - 1];
    };

    const latestLR = getLatestLRFile();

    const handleFileDownload = (file) => {
        downloadFileToLocal(file.fileUrl?.split("?")[0], file?.fileName);
    };

    const hasTrackingLinks = truck_details?.gps_link || truck_details?.other_link;

    return (
        <div className={styles.container}>
            {/* Vehicle & Driver Information Section */}
            <div className={styles.section}>
                <div className={styles.sectionHeader}>
                    <i className="fa fa-truck" aria-hidden="true"></i>
                    Vehicle & Driver Information
                </div>
                {truck_details && truck_details?.vehicle_no ? (
                    <table className={styles.vehicleTable}>
                        <thead>
                            <tr>
                                <th>Vehicle Number</th>
                                <th>Driver Name</th>
                                <th>Driver Mobile No.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{truck_details?.vehicle_no}</td>
                                <td>{truck_details?.driver_name || '-'}</td>
                                <td>{truck_details?.driver_phone_number || '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                ) : (
                    <div className={styles.noData}>No vehicle assigned</div>
                )}
            </div>

            {/* Tracking Links Section */}
            {hasTrackingLinks && (
                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <i className="fa fa-map-marker" aria-hidden="true"></i>
                        Tracking Links
                    </div>
                    <div className={styles.trackingLinks}>
                        {truck_details?.gps_link && (
                            <div className={styles.linkRow}>
                                <div className={styles.linkLabel}>GPS Link:</div>
                                <div className={styles.linkValue}>
                                    <a
                                        href={truck_details.gps_link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {truck_details.gps_link}
                                    </a>
                                </div>
                            </div>
                        )}
                        {truck_details?.other_link && (
                            <div className={styles.linkRow}>
                                <div className={styles.linkLabel}>Other Link:</div>
                                <div className={styles.linkValue}>
                                    <a
                                        href={truck_details.other_link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {truck_details.other_link}
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* SIM-Based Tracking Consent Section */}
            {hasAccess && truck_details && truck_details?.driver_phone_number && !location.pathname.includes('invoice') &&
                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <i className="fa fa-mobile" aria-hidden="true"></i>
                        SIM-Based Tracking Consent
                    </div>

                    <SimConsentStatus
                        restrictSimTracking={restrictSimTracking}
                        consentStatus={simConsentStatus}
                        loading={loadingConsentDetails}
                        isSendingRequest={isSendingRequest}
                        isCheckingStatus={isCheckingStatus}
                        onSendRequest={sendConsentRequest}
                        onCheckStatus={refetchSimTrackingStatus}
                        showInfoBox={true}
                    />
                </div>}

            {/* LR Details Section */}
            {lrDetails?.lr_generated && lrDetails?.display_lr_id && (
                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <i className="fa fa-file-text-o" aria-hidden="true"></i>
                        LR Details
                    </div>
                    <div className={styles.lrDetailsGrid}>
                        <div className={styles.lrLabel}>LR No.:</div>
                        <div className={styles.lrValue}>
                            {lrDetails?.display_lr_id || "-"}
                        </div>

                        {lrDetails.eway_bill_no && (
                            <>
                                <div className={styles.lrLabel}>Eway Bill No:</div>
                                <div className={styles.lrValue}>{lrDetails.eway_bill_no}</div>
                            </>
                        )}

                        {lrDetails?.user_lr_date && (
                            <>
                                <div className={styles.lrLabel}>LR Date:</div>
                                <div className={styles.lrValue}>{lrDetails.user_lr_date}</div>
                            </>
                        )}

                        {latestLR && (
                            <>
                                <div className={styles.lrLabel}>Action:</div>
                                <div className={styles.lrValue}>
                                    <button
                                        className={`btn btn-sm btn-link`}
                                        onClick={() => handleFileDownload(latestLR)}
                                    >
                                        <i className="fa fa-download mx-2"></i>
                                        Download LR
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default vehicleDetails;
